import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';

export const Root = styled(Box)(({ theme }) => ({
  width: '100%', 
  display: 'flex', 
  gap: '12px', 
  overflowX: 'auto',
  ...theme.scrollbars.default
}));